module.exports = __webpack_public_path__ + "static/media/SUMMIT.b3cdc194.png";